// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__DELri","sidemenu":"sidebar_sidemenu__UyMbd"};